import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import WarningIcon from '@material-ui/icons/Warning';
import { FC, ReactNode } from 'react';
interface Props {
  children: ReactNode;
  dialogOpen: boolean;
  handleOpen: () => void;
  deleteItem?: (id: string) => Promise<void> | void;
  deleteId: string;
}

const UIDialog: FC<Props> = (props) => {
  const handleDelete = () => {
    props.deleteItem && props.deleteItem(props.deleteId);
    props.handleOpen();
  };
  return (
    <div>
      <Dialog
        open={props.dialogOpen}
        onClose={props.handleOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="simple-dialog-title">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <WarningIcon />
            <span style={{ marginLeft: '5px' }}>削除</span>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.children}
            <br />
            この操作は取り消しできません。
            <br />
            本当に削除しますか？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={props.handleOpen} variant="outlined">
            戻る
          </Button>
          <Button
            autoFocus
            color="primary"
            variant="contained"
            onClick={handleDelete}
          >
            削除
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UIDialog;
